(ns ncr.widgets.dashboard
  (:require [ncr.charts :as charts]))

(defn view [{:keys [labels report fragments ignore-label? heading]}]
  [charts/c-overview-and-explain
   {:report report :fragments fragments :labels labels :ignore-label? ignore-label?
    :height 450 :heading heading}])
